"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _wouter = require("wouter");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _common = require("../../store/common");
var _course = require("../../store/course");
var _Style = require("../../style/Style");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const App = () => {
  const [location, setLocation] = (0, _wouter.useLocation)();
  const {
    isLoading,
    setIsLoading,
    setToastText,
    setToastOpen
  } = (0, _common.useCommonStore)();
  const {
    courses,
    errors,
    fetchCourses,
    deleteCourse
  } = (0, _course.useCourseStore)();
  (0, _react.useEffect)(() => {
    (async () => {
      setIsLoading(true);
      await fetchCourses();
      setIsLoading(false);
    })();
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    ...stylex.props(_Style.wrapper.main),
    spacing: 4,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      container: true,
      ...stylex.props(_Style.wrapper.mainTitle),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.textStyle.h1),
        children: "\u53D7\u8B1B\u3067\u304D\u308B\u30B3\u30FC\u30B9\u4E00\u89A7"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Stack, {
      direction: "row",
      spacing: 2,
      children: courses.length > 0 ? courses.map(course => /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Link, {
        href: `/course/detail/${course.id}`,
        ...stylex.props(_Style.textStyle.clearLinkDecoration),
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
          container: true,
          direction: "column",
          spacing: 1,
          ...stylex.props(_Style.wrapper.course),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: course.thumbnailPreviewUrl,
            alt: course.name,
            ...stylex.props(_Style.imageStyle.courseCard)
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            ...stylex.props(_Style.textStyle.h3),
            children: course.name
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
            container: true,
            direction: "column",
            spacing: 2,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ...stylex.props(_Style.textStyle.paragraph2),
              children: course.detail
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
              container: true,
              direction: "column",
              spacing: 0,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                ...stylex.props(_Style.textStyle.paragraph3),
                children: ["\u6559\u6750\u6570: ", course.lessonCount]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                ...stylex.props(_Style.textStyle.paragraph3),
                children: ["\u6559\u6750\u306E\u5408\u8A08\u6642\u9593: ", course.totalDurationText]
              })]
            })]
          })]
        })
      })) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.textStyle.p1b),
        children: errors.list || isLoading ? '読み込み中...' : '該当するコースが存在しません'
      })
    })]
  });
};
var _default = exports.default = App;